import { COMPANY_REQUEST_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
        path: "/super-admin/company-request",
        name: "company-request",
        component: () => import("@/views/super-admin/company-request/CompanyRequestView.vue"),
        meta: {
          gate: COMPANY_REQUEST_ACCESS,
          requiresSuperAdmin: true,
          pageTitle: "Company Request",
          layout: "super-admin",
        },
      },
  ];
  